import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-vendor-approval',
  templateUrl: './vendor-approval.component.html',
  styleUrls: ['./vendor-approval.component.scss'],
})
export class VendorApprovalComponent {
  loader:boolean = false;
  users;
  id;
  id1;
  type;
  search:any=[];
  filterLength;
  cloneUsers;
  contactNbrMob;
  Uid;
  empty:boolean=false;
  orgs : any=[];
  personalTog:boolean=false;
  header;
  category;
  allcategory;

  constructor(private service: ApiService,
    public handler: HandlerService,
    public pdf: PdfService,
    public router: Router,
    public payment:PaymentService,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService) { }

    ionViewWillEnter(){  
      this.id =localStorage.getItem('organizationId');   
      this.loader = true;
      this.header = 'Employee Approval';
      this.service.getUsersByOrg('SC',this.id,null).subscribe(res => {    
        this.users = res;
        this.users= this.users.filter(res =>{return res.verified == false})
        this.getCategory();  
      },err=>{
        this.handler.err(err)
        this.getCategory();
      })
  }

      click(id){
        if(this.personalTog){
          this.router.navigate(['/approveorg',id]);
        }
      }
       

      editProfile(id){
        if(this.personalTog)
        this.router.navigate(['org-profile/',id]);
        else
        this.router.navigate(['vendorProfile/',id]);
      }


      getOrgs() { 
        this.loader=true;
        this.personalTog = true;
        this.header ='vendor Approval';
        this.service.getPendingOrgs().subscribe(res=>{
          if(res){
            this.orgs = res;
            this.orgs= this.orgs.filter(res =>{return res.approvalStatus == 1});
            this.orgs.map(dat=>{
              if(dat.categories != null){
                Object.assign(dat,{cat:[]})
                dat.categories.map(dat1=>{
                  this.category.map(dat2=>{
                    if(dat1 == dat2.id){
                      dat.cat.push(dat2.name)
                    }
                  })
                })
              }
            })
            setTimeout(() => {
              this.loader=false;
            }, 1000);
          }else{
            this.handler.res("No Data Found");
            this.loader = false;
          }   
        })    
     }
       selectToggle(){
         if(this.personalTog){
           this.getOrgs();
         }else{
          this.ionViewWillEnter();
         }
       }

       getCategory(){
        this.service.getOrgCategory().subscribe((res: any) => {
          this.category=res;
          this.users.map(res=>{
            if(res.categoryLists)
            res.categoryLists.map(res1=>{
            this.category.map(dat=>{
              if(res1.categoryId == dat.id)
              Object.assign(res1,{catname:dat.name})
            }) 
            })
          })
       })
       setTimeout(() => {
        this.loader=false;
      }, 1000);
      }

      refreshData(event){
        if(!this.personalTog){
          this.ionViewWillEnter();
        }else{
          this.getOrgs();
        }
       
        setTimeout(() => {
          event.target.complete();
        }, 1000);
      }

      ionViewWillLeave(){
        this.search = "";
        this.personalTog = false;
      }
      clear(){
        this.search="";
      }
      ngDoCheck(): void {
        this.filterLength = sessionStorage.getItem('len')
      }
      
    }